// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__DH5Uk","Loader--Blue":"Loader_Loader--Blue__e_qRt","Loader--Yellow":"Loader_Loader--Yellow__1Hz8L","load7":"Loader_load7__0Z4DX"};